import { createContext, useContext } from "react";

/**
 * Which shop the current page belongs to. The public shop lives at /shop; the
 * B2B market (business prices) lives at /b2b/<key>, where <key> is the secret
 * part of the link the admin sends to business customers. Shop pages and
 * product cards read this to pick their API endpoints and links.
 */
const ShopMarketContext = createContext<string | undefined>(undefined);

export function ShopMarketProvider({
  b2bKey,
  children,
}: {
  b2bKey: string;
  children: React.ReactNode;
}) {
  return <ShopMarketContext.Provider value={b2bKey}>{children}</ShopMarketContext.Provider>;
}

/** Base path of a shop: /shop, or /b2b/<key> for the B2B market. */
export function shopBasePath(b2bKey?: string): string {
  return b2bKey ? `/b2b/${b2bKey}` : "/shop";
}

export function useShopMarket(): { b2bKey?: string; basePath: string } {
  const b2bKey = useContext(ShopMarketContext);
  return { b2bKey, basePath: shopBasePath(b2bKey) };
}
